//  This is a generated file, do not edit it directly
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgCheckedCheckbox } from '../icons/CheckedCheckbox';

export function CheckedCheckboxIcon(
  props: Omit<SvgIconProps, 'component' | 'children'>,
): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgCheckedCheckbox} data-qa="CheckedCheckboxIcon">
      <svg />
    </SvgIcon>
  );
}
